<script>
  import Form from "./Form.svelte";
  let step = 0;
  let data = {};
  let isStarted = false;
  const overrideClose = new URLSearchParams(window.location.search).has(
    "lateapplication",
  );
  async function startSubmission() {
    if (!isStarted) {
      isStarted = true;
      const response = await fetch(`/api`, { method: "PUT" });
      const initialData = await response.json();

      data.id = initialData.submissionId;
    }
  }
</script>

<div class="header full-bleed">
  <div id="megatitle">
    <img src="/casting-klassen-2025-logo.svg" alt="Casting Klassen 2025 logo" />
    <h1>Klassen</h1>
    {#if overrideClose}
      <h2>Kom med i den nye sæson af KLASSEN!</h2>
    {/if}
  </div>
</div>
<main>
  {#if !overrideClose}
    <h2>Castingen til DR Ultra serien KLASSEN er desværre lukket for i år.</h2>

    <p>
      Tak for alle jeres fantastiske ansøgninger – vi er så glade for den store
      interesse!
    </p>

    <p>
      De bedste hilsner,<br />
      KLASSEN-teamet
    </p>
  {:else if step === 0}
    <section class="intro">
      <h2>
        Vi leder efter børn i alderen 11-14 år i hele landet, som brænder for
        skuespil og har lyst til at være med i sæson 19 & 20 af KLASSEN.
      </h2>
      <h2>
        Optagelserne vil foregå i Storkøbenhavn i påskeferien og 4 uger i
        sommerferien 2025.
      </h2>
      <p>
        For at kunne ansøge skal du have tilladelse fra dine forældre/værger. De
        skal derfor uploade et billede af deres underskrift, som en del af
        ansøgningsproceduren. For at komme i betragtning til en rolle, skal du
        uploade 2 videoer. En præsentationsvideo og en scenevideo, så vi både
        ser dit talent og lærer lidt om dig som person. Instruktionerne finder
        du i næste trin.
      </p>
      <p id="important">
        <strong
          >Ansøgningsfristen for castingen er 5. februar 2025 kl. 23.59.</strong
        >
      </p>
      <p>Held og lykke! Vi glæder os til at høre fra dig.</p>
      <p>De bedste hilsner, KLASSEN-temaet</p>
      <div class="nav-buttons">
        <button
          class="plausible-event-name=step1"
          on:click={() => {
            step++;
            window.scrollTo(0, 0);
          }}>Ansøg her</button
        >
      </div>
    </section>
  {:else if step === 1}
    <section>
      <h2>Video 1 - sådan optager du din præsentationsvideo</h2>
      <p>I præsentationsvideoen skal du fortælle om dig selv, herunder:</p>
      <ul class="plain-list">
        <li>- navn</li>
        <li>- alder</li>
        <li>- by</li>
        <li>- hobbyer</li>
        <li>- erfaring med at stå på en scene</li>
        <li>- motivation for at være med i klassen</li>
      </ul>
      <p>Hvis du har en særlig skill, må du også gerne vise den i videoen.</p>
      <h2>Video 2 - Sådan optager du din skuespilsvideo</h2>
      <p>
        Din bedste ven ringer til dig. Du er i godt humør og tror, vennen
        ringer, fordi I skal hænge ud i aften. Men i virkeligheden vil vennen
        fortælle, at han/hun i stedet har lavet en aftale med din anden bedste
        ven, som du har introduceret ham/hende for. Hvad gør du?
      </p>
      <h2>Tilladelse fra dine forældre:</h2>
      <p>
        Når du sender din ansøgning, skal du også have et billede af en af dine
        forældres/værgers underskrifter, som bevis på, at du har deres
        tilladelse til at ansøge om at komme i betragtning til en rolle i
        KLASSEN.
      </p>
      <div class="nav-buttons">
        <button
          class="secondary plausible-event-name=go-back"
          on:click={() => {
            step--;
            window.scrollTo(0, 0);
          }}>Tilbage</button
        >
        <button
          class="plausible-event-name=step2"
          on:click={() => {
            step++;
            window.scrollTo(0, 0);
            startSubmission();
          }}>Næste</button
        >
      </div>
    </section>
  {:else}
    <Form bind:step bind:data />
  {/if}
</main>

<style>
  .header {
    position: relative;
    height: 45vw;
    max-height: 370px;
  }
  .header #megatitle {
    width: 90%;
    position: absolute;
    bottom: 0vw;
    left: 5%;
    top: auto;
  }
  .header #megatitle h2 {
    font-size: 4.8vw;
    text-align: center;
  }
  .header h1 {
    position: absolute;
    display: block;
    height: 0;
    width: 0;
    overflow: hidden;
  }
  .header img {
    width: 100%;
    max-height: 500px;
    object-fit: cover;
  }
  @media (min-width: 1000px) {
    .header.full-bleed > * {
      margin: 0 auto;
    }
    .header #megatitle {
      left: 0;
      max-width: 900px;
      left: calc((100% - 900px) / 2);
      position: absolute;
    }
    .header #megatitle h2 {
      font-size: 48px;
    }
  }
  main {
    margin-top: 0px;
    padding: 16px;
    color: var(--primary-color);
    line-height: 1.4;
    max-width: 100%;
  }
  @media (min-width: 350px) {
    main {
      min-width: 350px;
    }
  }

  h1 {
    text-transform: uppercase;
    font-size: 2em;
  }
  h2 {
    margin-top: 2rem;
    margin-bottom: -0.3rem;
  }
  .intro h2 {
    font-size: 1.2rem;
  }
  .intro h2 + h2 {
    margin-top: 0.5rem;
  }
  #important {
    margin: 2rem 0;
  }
  button.secondary {
    border: 0;
  }
  .plain-list {
    margin-top: -8px;
    list-style: none;
    margin-left: 0;
  }
</style>
